export default __webpack_public_path__ + "static/media/EM0700.34I-41832_-25096_0.6facc0e8.jpg";